import React from 'react';
import styles from './style.module.css';

interface ILoadingSpinProps {
  size?: number;
  thickness?: number;
  color?: string;
}

export const LoadingSpin: React.FC<ILoadingSpinProps> = ({
  size = 30,
  thickness = 3,
  color = 'var(--color-button-primary)',
}) => {
  return (
    <span
      className={styles.loader}
      style={
        {
          width: size,
          height: size,
          '--loader-thickness': `${thickness}px`,
          '--loader-color': color,
        } as React.CSSProperties
      }
    />
  );
};

export default LoadingSpin; // Maintain the default export for backwards compatibility
